import { defineStore } from 'pinia';
import { ref, nextTick } from 'vue';
import type { EmailSheetContentProps } from './EmailSheetContent.vue';

export const useMultiEmailStore = defineStore('multiEmail', () => {
  const selectedContact = ref<EmailSheetContentProps | null>(null);

  const openEmail = async (contact: EmailSheetContentProps) => {
    selectedContact.value = null;
    await nextTick();
    selectedContact.value = contact;
  };

  const closeEmail = () => {
    selectedContact.value = null;
  };

  return { selectedContact, openEmail, closeEmail };
});
